import AppDataService from "./AppDataService";

export default class DashboardService {
  static async getDashboardData(data) {
    const queryParams = [
      data?.start ? `start=${data.start}` : "",
      data?.end ? `end=${data.end}` : "",
    ]
      .filter(Boolean)
      .join("&");

    const queryString = queryParams ? `?${queryParams}` : "";
    return await AppDataService.get(`admin/dashboard${queryString}`);
  }

  static async getDashboardGraph(data) {
    const queryParams = [
      data?.key ? `key=${data.key}` : "",
      data?.startDate ? `startDate=${data.startDate}` : "",
      data?.endDate ? `endDate=${data.endDate}` : "",
    ]
      .filter(Boolean)
      .join("&");

    const queryString = queryParams ? `?${queryParams}` : "";
    return await AppDataService.get(`dashboard/graph${queryString}`);
  }

  static async getFacilityDashboardData(data) {
    const queryParams = [
      data?.facilityId ? `facilityId=${data.facilityId}` : "",
      data?.pageNumber >= 0 ? `pageNumber=${data.pageNumber}` : "",
      data?.limit ? `limit=${data.limit}` : "",
    ]
      .filter(Boolean)
      .join("&");
    const queryString = queryParams ? `?${queryParams}` : "";
    return await AppDataService.get(`dashboard/facility${queryString}`);
  }

  // Top ICD-10 / DSM codes being seen, with the facilities that recorded them.
  // startDate/endDate are UTC ISO instants for the chosen window (calendar day,
  // week, or an IAP operational period). facilityId is optional — omitting it
  // reports across all facilities, which is what the admin dashboard shows.
  static async getIcdSummary(data) {
    const queryParams = [
      data?.startDate ? `startDate=${data.startDate}` : "",
      data?.endDate ? `endDate=${data.endDate}` : "",
      data?.facilityId ? `facilityId=${data.facilityId}` : "",
      data?.codeType ? `codeType=${data.codeType}` : "",
      data?.limit ? `limit=${data.limit}` : "",
    ]
      .filter(Boolean)
      .join("&");

    const queryString = queryParams ? `?${queryParams}` : "";
    return await AppDataService.get(`dashboard/icd-summary${queryString}`);
  }

  static async getFacilityRooms(data) {
    // facilityId is optional — only send it when a specific facility is selected.
    const queryParams = [data?.facilityId ? `facilityId=${data.facilityId}` : ""]
      .filter(Boolean)
      .join("&");

    const queryString = queryParams ? `?${queryParams}` : "";
    return await AppDataService.get(`dashboard/facility/rooms${queryString}`);
  }
}
